module.exports = __webpack_public_path__ + "img/edit.da439f18.png";